import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"
import _imports_0 from '../assets/mh.png'


const _hoisted_1 = { class: "section dark about-section grid grid-cols-2 sm-grid-cols-1 md-grid-cols-1" }
const _hoisted_2 = {
  key: 0,
  class: "section-header"
}
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Mediocre Hobbies Logo"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", null, [
      (_ctx.showHeading)
        ? (_openBlock(), _createElementBlock("h3", _hoisted_2, _toDisplayString(_ctx.heading), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", { innerHTML: _ctx.htmlContent }, null, 8, _hoisted_3)
    ]),
    _hoisted_4
  ]))
}